import * as FileManager from '../../SDK/FileManager'
import * as Util from '../../common/js/util'

const SHOW_LIST = true
const HIDE_LIST = false
const fileInfo = {
  state: {
    isShow: true, // 是否显示文件列表
    // 是否需要重新加载filelist
    isReloadFilelist: false,
    // 是否为搜索模式
    isSearch: false,
    // 当前操作的文件
    currentFile: {},
    // 当前操作的文件的更多信息
    currentFileDetailMore: {},
    // 是否显示当前文件详情
    isShowFileDetail: false,
    // 是否显示当前文件的更多信息
    detailMore: false,
    // 创建文件夹后台返回的错误提示
    // isAddFolderErr: '',
    // 共享下文件重命名
    // isShareRenameError: '',
    // 当前目录信息
    currentFolder: {
      // 当前目录权限
      access_mode: 4095,
      // 路径类型
      path_type: 'ent',
      // 是否包含删除文件
      include_deleted: false,
      // 每页显示条数
      limit: 20,
      // 本次查询起始索引
      offset: 0,
      // 排序(升序、降序)
      sort: 'desc',
      // from
      from: '',
      // from_name
      from_name: '',
      // prefix_neid
      prefix_neid: '',
      // 排序类型
      orderBy: 'mtime',
      // 当前全路径
      fullPath: '',
      // 是否还有下一页
      haveMore: true,
      // 正在加载
      isLoading: true,
      // 当前路径
      path: '/',
      // 文件类型
      dir_type: ''
    },
    // 当前列表内容
    content: [],
    // 当前列表搜索内容
    searchContent: [],
    // 确认删除提示
    confirmTipsIsShow: '',
    // tip的标题
    tipsTitle: '',
    // 再次确认
    againConfirm: false,
    // 重命名组件
    renameDialogIsShow: false,
    // 新建文件夹
    addFolderShow: false,
    // 当前文件index
    currentIndex: 0,
    // 根路径名称
    rootPathName: '企业空间',
    // 数据中心
    region: ''
  },
  getters: {
    // 获取当前选中的文件索引
    getCurrentIndex: state => state.currentIndex,
    // 获取当前文件夹中文件信息
    getFileList: state => state.content,
    // 获取当前文件夹中文件信息
    getSearchList: state => state.searchContent,
    // 获取当前文件夹信息
    getCurrentFolderInfo: state => state.currentFolder,
    // 获取当前选中文件信息
    getCurrentFile: state => state.currentFile,
    // 获取当前选中文件更多信息
    getCurrentFileDetailMore: state => state.currentFileDetailMore,
    // 获取当前选中文件更多信息
    isShowDetailMore: state => state.detailMore,
    // 获取当前选中文件更多信息
    isShowFileDetail: state => state.isShowFileDetail,
    // 获取当前文件夹每页条数
    getCurrentFolderLimit: state => state.currentFolder.limit,
    // 获取当前文件夹排序方式
    getCurrentFolderSort: state => state.currentFolder.sort,
    // 获取当前文件夹排序方式
    getCurrentFolderOrderBy: state => state.currentFolder.orderBy,
    // 获取当前文件夹是否包含已删除文件
    getCurrentFolderIncludeDeleted: state => state.currentFolder.include_deleted,
    // 获取当前文件夹是否包含已删除文件
    getCurrentFolderAccessMode: state => state.currentFolder.access_mode,
    // 获取当前路径
    getCurrentPath: state => state.currentFolder.fullPath,
    // 获取是否还有下一页
    getCurrentHaveMore: state => state.currentFolder.haveMore,
    // 获取当前是否正在加载
    getCurrentsLoading: state => state.currentFolder.isLoading,
    // 获取当前路径
    getCurrentFolderOffset: state => state.currentFolder.offset,
    // 获取当前路径
    getRootPathName: state => state.rootPathName,
    // 获取全路径
    getFullPath: state => state.currentFolder.path,
    // 获取全路径
    getIsDeletingFile: state => state.currentFolder.deletingFile,
    // 删除提示框是否显示
    getTipsIsShow: state => state.confirmTipsIsShow,
    // 重命名是否显示
    getRenameIsShow: state => state.renameDialogIsShow,
    // 重命名是否显示
    getIsSearch: state => state.isSearch,
    // 获取全路径
    getCurrentPathType: state => state.currentFolder.path_type
  },
  mutations: {
    showFileList (state) {
      state.isShow = SHOW_LIST
    },
    hideFileList (state) {
      state.isShow = HIDE_LIST
    },
    intoItem (state, obj) {
      state.currentFile = obj.param
      state.currentFolder.fullPath = obj.param.name
    },
    showConfirmTips (state, obj) {
      state.confirmTipsIsShow = obj
    },
    hideConfirmTips (state) {
      state.confirmTipsIsShow = ''
    },
    showRenameDialog (state) {
      state.renameDialogIsShow = true
    },
    hideRenameDialog (state) {
      state.renameDialogIsShow = false
    },
    setAgainTipTitle (state, obj) {
      state.tipsTitle = obj
    },
    setAgainConfirm (state, obj) {
      state.againConfirm = obj
    },
    // 插入当前文件夹中文件信息
    setFileList (state, obj) {
      var files = []
      var contents = obj.content
      for (let i = 0; i < contents.length; i++) {
        var file = {}
        var item = {}
        if (contents[i].snapshot) {
          item = contents[i].snapshot
          item.path_type = contents[i].snapshot.path_type
          item.bookmark_id = contents[i].id
          item.is_bookmark = false
        } else {
          item = contents[i]
        }
        var d = Util.resolvePath(item.path, item.is_dir)
        item.type = d.type
        item.typeIcon = Util.typeIcon(d.type)
        item.name = d.name
        item.title = file.name
        item.filename = file.name
        item.size = Util.formatBytes(item.bytes)
        item.datetime = Util.formatDate(item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm')
        item.authName = Util.getAuthNameByAccessMode(item.access_mode).authName
//          file.hasDelivery = item.delivery_code ||item.hasDelivery ? true : false
//          file.islocked = item.lock_uid ? true : false
//          file.deliveryTitle = file.hasDelivery ? _('查看外链') : _('外链分享')
        if (item.dir_type === 2 || item.dir_type === 4) { // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true
          if (item.dir_type === 2) {
            item.is_shared = true
          }
        } else {
          item.is_cloud = false
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team'
          } else if (item.is_shared && item.is_cloud) { // 云端文件被共享
            item.typeIcon = 'cloud_share'
          } else if (item.is_cloud) { // 云端文件
            item.typeIcon = 'folder_cloud'
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share'
          } else if (item.is_team) {
            item.typeIcon = 'folder_team'
          } else {
            item.typeIcon = 'folder'
          }
        }
        switch (item.dir_type) {
          case 1 :
            item.category = '团队文件夹'
            break
          case 2 :
            item.category = '云端共享文件夹'
            break
          case 4 :
            item.category = '云端文件夹'
            break
          case 6 :
            item.category = '共享文件夹'
            break
          case 8 :
            item.category = '普通文件'
            break
          default :
            item.category = '普通文件夹'
            break

        }
        if (item.is_shared) {
          if (!item.is_team) {
//              file.category = _('共享文件夹')
          } else {
//              if (item.path_type === "self"&& Util.isAdmin()) {
//                file.category = _('普通文件夹')
//              } else {
//                file.category = _('团队文件夹')
//              }
          }
        } else {
//            file.category = _("普通文件夹")
        }
        if (!item.is_dir) {
          item.rev = item.rev
          item.version = item.rev_index > 999 ? '999+' : item.rev_index
        }
        files.push(item)
      }
      // console.log('offset:' + state.currentFolder.offset)
      if (state.currentFolder.offset > 0) {
        state.content = state.content.concat(files)
      } else {
        state.content = files
      }
    },
    setFavoriteFileList (state, obj) {
      var files = []
      var contents = obj.content
      for (let i = 0; i < contents.length; i++) {
        var file = {}
        var item = {}
        if (contents[i].snapshot) {
          item = contents[i].snapshot
          item.path_type = contents[i].snapshot.path_type
        } else {
          item = contents[i]
          item.bytes = 0
          item.isFileModify = true     //  源文件被修改或者已删除
        }
        item.is_bookmark = false
        item.bookmark_id = contents[i].id
        item.path = contents[i].title
        item.modified = contents[i].ctime
        var d = Util.resolvePath(item.path)
        if (d.type === '') {
          d.type = 'folder'
          item.is_dir = true
        }
        item.type = d.type
        item.typeIcon = Util.typeIcon(d.type)
        item.name = d.name
        item.title = file.name
        item.filename = file.name
        item.size = Util.formatBytes(item.bytes)
        item.datetime = Util.formatDate(item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm')
        item.authName = Util.getAuthNameByAccessMode(item.access_mode).authName
        if (item.dir_type === 2 || item.dir_type === 4) { // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true
          if (item.dir_type === 2) {
            item.is_shared = true
          }
        } else {
          item.is_cloud = false
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team'
          } else if (item.is_shared && item.is_cloud) { // 云端文件被共享
            item.typeIcon = 'cloud_share'
          } else if (item.is_cloud) { // 云端文件
            item.typeIcon = 'folder_cloud'
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share'
          } else if (item.is_team) {
            item.typeIcon = 'folder_team'
          } else {
            item.typeIcon = 'folder'
          }
        }
        switch (item.dir_type) {
          case 1 :
            item.category = '团队文件夹'
            break
          case 2 :
            item.category = '云端共享文件夹'
            break
          case 4 :
            item.category = '云端文件夹'
            break
          case 6 :
            item.category = '共享文件夹'
            break
          case 8 :
            item.category = '普通文件'
            break
          default :
            item.category = '普通文件夹'
            break

        }
        if (item.is_shared) {
          if (!item.is_team) {
//              file.category = _('共享文件夹')
          } else {
//              if (item.path_type === "self"&& Util.isAdmin()) {
//                file.category = _('普通文件夹')
//              } else {
//                file.category = _('团队文件夹')
//              }
          }
        } else {
//            file.category = _("普通文件夹")
        }
        if (!item.is_dir) {
          item.rev = item.rev
          item.version = item.rev_index > 999 ? '999+' : item.rev_index
        }
        files.push(item)
      }
      // console.log('offset:' + state.currentFolder.offset)
      if (state.currentFolder.offset > 0) {
        state.content = state.content.concat(files)
      } else {
        state.content = files
      }
    },
    setSearchFileList (state, obj) {
      state.searchContent = []
      state.searchContent = obj.content
    },
    clearSearchFileList (state, obj) {
      state.searchContent = []
    },
    // 插入当前文件夹信息
    setCurrentFolderInfo (state, obj) {
      for (let o in state.currentFolder) {
        if (obj[o]) {
          state.currentFolder[o] = obj[o]
        }
      }
    },
    setRootPathName (state, obj) {
      state.rootPathName = obj
    },
    setFullPath (state, obj) {
      state.currentFolder.path = obj
    },
    setCurrentPathType (state, obj) {
      // 设置当前
      if (obj) {
        state.currentFolder.path_type = obj.param.path_type
      } else {}
      // 重置分页参数和排序参数
      // state.currentFolder.sort = 'desc'
      // state.currentFolder.orderBy = 'mtime'
      state.currentFolder.haveMore = true
    },
    setSort (state, obj) {
      state.currentFolder.sort = obj.param.sort
      state.currentFolder.orderBy = obj.param.orderBy
    },
    setIsLoading (state, obj) {
      state.currentFolder.isLoading = true
    },
    clearIsLoading (state, obj) {
      state.currentFolder.isLoading = false
    },
    setHaveMore (state, obj) {
      state.currentFolder.haveMore = obj
    },
    setOffset (state, obj) {
      state.currentFolder.offset = obj
    },
    addOffset (state, obj) {
      state.currentFolder.offset += obj
    },
    setDeletingFile (state, obj) {
      state.currentFolder.deletingFile = obj
    },
    setAddFolderShow (state, obj) {
      state.addFolderShow = obj
    },
    setCurrentFileDetailMore (state, obj) {
      state.currentFileDetailMore = obj
    },
    setCurrentFileDetailMoreShow (state, obj) {
      state.detailMore = obj
    },
    setCurrentFileDetailMoreHide (state) {
      state.detailMore = false
    },
    setCurrentFileDetailShow (state) {
      state.isShowFileDetail = true
    },
    setCurrentFileDetailHide (state) {
      state.isShowFileDetail = false
    },
    setIsReloadFilelist (state, obj) {
      // state.currentFolder.page_num = 0
      state.isReloadFilelist = obj
      // state.currentFolder.offset = 0
    },
    setRegion (state, obj) {
      state.region = obj
    },
    setIsSearch (state, obj) {
      state.isSearch = obj
    }
  },
  actions: {
    set_MusicAllList ({commit}, obj) {
      commit('setMusicAllList', obj)
    },
    // 获取文件列表
    get_FileList ({commit, rootState}, obj) {
      commit('setIsLoading')
      if (rootState.fileInfo.currentFolder.haveMore) {
        if (rootState.fileInfo.currentFile.from && rootState.fileInfo.currentFile.from !== '') {
          obj.param.from = rootState.fileInfo.currentFile.from
        }
        if (rootState.fileInfo.currentFile.prefix_neid && rootState.fileInfo.currentFile.prefix_neid !== '') {
          obj.param.prefix_neid = rootState.fileInfo.currentFile.prefix_neid
        }
        if (rootState.fileInfo.currentFolder.path_type === 'favorite') {
          obj.param.path_type = rootState.fileInfo.currentFile.path_type
        }
        FileManager.metaData(obj.param).then(response => {
          commit('clearIsLoading')
          if (response.content.length === 0) {
            // return
          }
          commit('setHaveMore', response.content.length === rootState.fileInfo.currentFolder.limit)
          commit('setFileList', response)
          commit('setCurrentFolderInfo', response)
        }, err => {
          commit('clearIsLoading')
          console.log(err)
        })
      }
    },
    getFileDetail ({commit}, obj) {
      FileManager.info(obj.param).then(response => {
        if (response) {
          commit('setCurrentFileDetailMore', response)
          commit('setCurrentFileDetailMoreShow', true)
        }
      }, err => {
        console.log(err)
      })
    },
    renameFileName ({commit, state}, obj) {
      if (state.againConfirm) {
        obj.ignore_share = true
      }
      FileManager.rename(obj).then(response => {
        commit('clearIsLoading')
        if (response.result !== 'success') {
          return
        }
        commit('setToast', {isShow: true, message: '重命名成功', iconClass: 'icon-success'})
        commit('setIsReloadFilelist', true)
        commit('setAgainConfirm', false)
      }, err => {
        if (err.state === 412) {
          commit('setAgainTipTitle', err.message)
          commit('setAgainConfirm', true)
          commit('setToast', {isShow: true, message: '重命名成功', iconClass: 'icon-success'})
        } else if (err.state === 403) {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
          // commit('setShareRenameError', err.message)
        } else {
          commit('setToast', {isShow: true, message: '重命名失败', iconClass: 'icon-error'})
        }
        console.log(err)
      })
    },
    deleteFile ({commit, state}, obj) {
      commit('setDeletingFile', true)
      var deleteFile = {
        'neid': obj.params.neid,
        'path': obj.params.path,
        'from': obj.params.from,
        'path_type': obj.params.path_type,
        'prefix_neid': obj.params.prefix_neid
      }
      if (state.againConfirm) {
        deleteFile.ignore_share = true
      }
      FileManager.batchDelete(deleteFile).then(response => {
        commit('clearIsLoading')
        if (response.success.length !== 0) {
          commit('setToast', {isShow: true, message: '删除成功', iconClass: 'icon-success'})
          commit('setIsReloadFilelist', true)
          commit('setAgainConfirm', false)
        }
      }, err => {
        if (err.state === 412) {
          commit('setAgainTipTitle', err.message)
          commit('setAgainConfirm', true)
          commit('showConfirmTips', 'confirmDelete')
        } else {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        }
      })
    },
    set_SearchFileList ({commit, rootState}, obj) {
      rootState.searchKeyword = obj.query
      obj['path_type'] = rootState.fileInfo.currentFolder.path_type
      obj['path'] = rootState.fileInfo.currentFolder.fullPath
      FileManager.search(obj).then(response => {
        commit('clearIsLoading')
        if (response) {
          commit('setSearchFileList', response)
        }
      }, err => {
        commit('clearIsLoading')
        console.log(err)
      })
    },
    clear_SearchFileList ({commit}, obj) {
      commit('clearSearchFileList', obj)
    },
    set_RootPathName ({commit}, obj) {
      commit('setRootPathName', obj)
    },
    intoItem ({commit}, obj) {
      commit('intoItem', obj)
    },
    setCurrentPathType ({commit}, obj) {
      commit('setCurrentPathType', obj)
    },
    setCurrentFolderNextPageNum ({commit}, obj) {
      commit('setCurrentFolderNextPageNum', obj)
    },
    set_Sort ({commit}, obj) {
      commit('setSort', obj)
    },
    addFolder ({commit, rootState}, obj) {
      let params = {
        path: '/' + rootState.fileInfo.currentFolder.path + '/' + obj,
        path_type: rootState.fileInfo.currentFolder.path_type,
        prefix_neid: rootState.fileInfo.currentFolder.prefix_neid,
        from: rootState.fileInfo.currentFolder.from
      }
      FileManager.createFolder(params).then(response => {
        if (response.result === 'success') {
          let params = {
            isShow: true,
            message: '添加文件夹成功',
            iconClass: 'icon-success'
          }
          commit('setToast', params)
          commit('setIsReloadFilelist', true)
          commit('setAddFolderShow', false)
        }
      }, err => {
        if (err.type === 'error') {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
          // commit('setAddFolderError', err.message)
        }
      })
    },
    setFavorite ({commit}, obj) {
      FileManager.setFavorite(obj).then(response => {
        commit('setToast', {isShow: true, message: '收藏成功', iconClass: 'icon-success'})
        commit('setIsReloadFilelist', true)
      }, err => {
        if (err.type === 'error') {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        }
      })
    },
    cancelFavorite ({commit}, obj) {
      FileManager.removeFavorite(obj).then(response => {
        if (obj.isRemoveFavorite) {
          commit('setToast', {isShow: true, message: '此条收藏已被移除', iconClass: 'icon-success'})
        } else {
          commit('setToast', {isShow: true, message: '已取消收藏', iconClass: 'icon-success'})
        }
        commit('setIsReloadFilelist', true)
      }, err => {
        if (err.type === 'error') {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        }
      })
    },
    getFavoriteList ({commit, rootState}, obj) {
      FileManager.getFavorite(obj).then(response => {
        // commit('setHaveMore', response.content.length === rootState.fileInfo.currentFolder.limit)
        commit('setFavoriteFileList', response)
        // commit('setCurrentFolderInfo', response)
      }, err => {
        console.log(err)
      })
    }
  }
}
export default fileInfo



// WEBPACK FOOTER //
// ./src/store/modules/filelist.js